<template>
    <b-container fluid class="animated fadeIn">
        <h1>Ajuizamento - Exibir Processos Montados</h1>
        <b-card>
            <b-row>
                <b-col md="12">
                    <div class="d-flex justify-content-between">
                        <div>
                            <b-button class="mx-1 fonte-branca" v-b-toggle.collapseOpcoesPesquisa variant="primary"><i class="fa fa-filter"></i> Opções de pesquisa</b-button>
                            <CompExibirOcultarColuna 
                                :fields="fields"
                                :showColunms="showColunms" 
                                @toggleColuna="toggleColuna" />
                        </div>
                    </div>
                    <CompOpcoesPesquisa
                        :filtro="filtro"
                        :dados="dados"
                        @filtrar="filtrar"
                        @limparFiltro="limparFiltro" />
                    <b-row class="d-flex justify-content-between mt-2">
                        <CompAvisos />
                        <b-col align-self="end">
                            <div class="d-flex justify-content-between mb-3" style="float:right">
                                <div>
                                    <b-button class="mx-1 " variant="primary" @click.prevent="desmontarProcesso" :disabled="!selecteds.length"><i class="fa fa-pencil-square-o"></i> Desmontar Processo</b-button>
                                    <b-button class="mx-1" variant="primary" :disabled="!selecteds.length" @click.prevent="show()"> Ajuizar</b-button>
                                </div>
                            </div>
                        </b-col>
                    </b-row>
                    <b-row class="mt-3">
                        <b-col xs="12" md="12" class="mx-auto">
                            <b-col xs="12">
                                <div>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col>
                                            <label class="mt-3">Processos Montados - Valor Total: <strong>R$ {{ configTable.totalGeral | currency }}</strong> &nbsp; CDA's: <strong>{{ configTable.quantidadeGeral }}</strong> Processos: <strong>{{ configTable.totalProcessos }}</strong></label>
                                        </b-col>
                                        <b-col>
                                            <div>
                                                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm" class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
                                                </b-pagination>
                                                <b-form-select v-model="configTable.perPage" :options="[200, 500, 1000, 'Todos']" size="sm" class="mb-3 col-2" style="float:right"></b-form-select>
                                            </div>
                                        </b-col>
                                    </b-row>
                                    <CompTabelaExibirProcessosMontados
                                        :resultado="resultado"
                                        :fields="fields"
                                        :configTable="configTable"
                                        :selecteds="selecteds"
                                        @sortingChanged="consultarDividas"
                                        @consultarDividas="consultarDividas"
                                        @limparSelecionados="limparSelecionados"
                                         />
                                    <b-row class="d-flex justify-content-between">
                                        <b-col align-self="end">
                                            <label style="float:right">Processos:{{ totalProcessos }} &nbsp; CDA's selecionadas: {{ selecteds.length }} &nbsp; Valor Total: <strong>R$ {{ totalSelectedValue | currency }}</strong></label>
                                        </b-col>
                                    </b-row>
                                    <b-row class="d-flex justify-content-between">
                                        <b-col></b-col>
                                        <b-col>
                                            <div>
                                                <b-pagination v-model="configTable.currentPage" :per-page="configTable.perPage" :total-rows="configTable.rows" size="sm" class="pl-3" style="float:right" v-if="configTable.perPage != 'Todos'">
                                                </b-pagination>
                                                <b-form-select v-model="configTable.perPage" :options="[200, 500, 1000, 'Todos']" size="sm" class="mb-3 col-2" style="float:right"></b-form-select>
                                            </div>
                                        </b-col>
                                    </b-row>
                                </div>
                            </b-col>
                        </b-col>
                    </b-row>
                    <b-row class="justify-content-center">
                        <div class="d-flex justify-content-between mb-3">
                            <div>
                                <b-button class="mx-1 " variant="primary" :disabled="loadCSV"  @click.prevent="exportCSV()"><i class="fa fa-cloud-download" v-if="!loadCSV"></i>
                                    <b-spinner small v-if="loadCSV"></b-spinner>
                                    Exportar CSV
                                </b-button>
                                <b-button class="mx-1" variant="secondary" @click="voltar()"><i class="fa fa-reply"></i> Voltar</b-button>
                                <b-button class="mx-1 " variant="primary" @click="abrirCdasDisponiveis()">
                                    <i class="fa fa-arrow-left"></i>
                                    Volta tela anterior
                                </b-button>
                                <b-button class="mx-1 " variant="primary" @click="abrirCdasAjuizadas()">
                                    <i class="fa fa-arrow-right"></i>
                                    Avança próxima tela
                                </b-button>
                            </div>
                        </div>
                    </b-row>
                </b-col>
            </b-row>
            <b-modal ref="modalBry" size="lg" title="Modal Bry" cancel-title="Fechar">
                <Certificado :param="parametrosAssinatura" @finalizarAssinatura="processarArquivoAssinado($event)" @erroAssinatura="processarErroAssinatura($event)"/>	
            </b-modal>
        </b-card>
    </b-container>
</template>

<script>
import axios from 'axios'
import CompOpcoesPesquisa from './components/CompOpcoesPesquisaMontarProcessos'
import CompAvisos from './components/CompAvisos'
import CompExibirOcultarColuna from './components/CompBotaoExibirOcultarColuna'
import CompTabelaExibirProcessosMontados from './components/CompTabelaExibirProcessosMontados'
import apiCentralSeguranca from '@/api/centralseguranca';
import Certificado from "assinador-bry";

export default {
    name: 'ExibirProcessosMontados',
    components: {
        CompOpcoesPesquisa,
        CompAvisos,
        CompExibirOcultarColuna,
        CompTabelaExibirProcessosMontados,
        Certificado,
    },
    data() {
        return {
            ano: null,
            mes: null,
            cpfUsuarioLogado: null,
            filtro: {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
            },
            parametrosAssinatura: {
                config: {
                 padraoAssinatura: "1",
                 tipoAssinatura: "Attached",
                 incluiCadeia: true,
                },
                filters: {
                    CPFS:[]
                },
                ambiente: process.env.VUE_APP_BRY_AMBIENTE,
                arquivo: this.listaPdfsRetorno,
                token: JSON.parse(this.$store.getters.getUser).access_token,
                 consumerId : 'PGEPROAJU',
                realizarDownloadArquivoAssinado: false
            },
            dados: {
                comarcas: [],
                creditos: []
            },
            configTable: {
                perPage: 200,
                sortField: 'contribuinte',
                sortOrder: 'asc',
                currentPage: 1,
                rows: 0,
                checkedAll: false,
                load: false,
                totalGeral: 0.00,
                quantidadeGeral: 0,
                permitirAjuizar: false
            },
            showColunms: [],
            selecteds: [],
            processosSelecionados: [],
            fields: [
                {
                    key: "selecionar",
                },
            ],
            resultado: [],
            listaPdfsRetorno: [],
            loadCSV: false,
            timer: '',
            tempoAtualizacaoPagina: null,
        }
    },
    watch: {
        perPage() {
            this.configTable.checkedAll = false
            this.processosSelecionados = []
            this.selecteds = []
            this.configTable.currentPage = 1
            this.consultarDividas()
        }
    },
    computed: {
        perPage() {
            return this.configTable.perPage
        },
        totalSelectedValue() {
            let total = 0.00
            this.selecteds.forEach(divida => {
                total = total + divida.valor
            })
            return total
        },
        totalProcessos() {
            let total = 0
            this.processosSelecionados = []
            this.selecteds.forEach(divida => {
                if(!this.processosSelecionados.includes(divida.codProcesso)) {
                    this.processosSelecionados.push(divida.codProcesso)
                }
            })
            return this.processosSelecionados.length
        },
        totalResultValue() {
            let total = 0.00
            this.resultado.forEach(result => {
                result.dividas.forEach(divida => {
                    total = total + divida.valor
                })
            })
            return total
        },
    },
    methods: {
        escapePerPage() {
            if (this.configTable.perPage == 'Todos') {
                return '';
            }
            return '&perPage='  + this.configTable.perPage
        },
        processarErroAssinatura(erro){
            alert(erro)
        },
        processarArquivoAssinado(arquivosAssinadosB64){
            //enviar arquivo servidor, realizar download.

            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/exibirProcessosMontados/ajuizar`, arquivosAssinadosB64, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Processo(s) ajuizados(s) com sucesso!'] });
                this.selecteds = []
            })
            .catch((error) => {
                if(error.response.status === 400){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro ocorreu durante o processamento. Tente novamente mais tarde.'] });
                }
                if(error.response.status === 500){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro de comunicação ocorreu com um sistema externo, tente novamente mais tarde. <a href="www.google.com">TESTE</a>'] });
                }
                this.selecteds = []
            })   
            .finally(() => {
                this.loadingExit()
                this.configTable.checkedAll = false
                this.consultarDividas()
            })

        },
        /**
         * Limpar os filtros de pesquisa
         */
        limparFiltro() {
            this.filtro = {
                numeroDivida: null,
                cpfCnpj: null,
                contribuinte: null,
                cadimcs: null,
                comarca: null,
                credito: null,
                dtInscricaoInicio: null,
                dtInscricaoFim: null,
            }
        },

        /**
         * Filtrar a consulta
         */
        filtrar() {
            this.configTable.currentPage = 1
            this.selecteds = []
            this.consultarDividas()
        },

        limparSelecionados(){
            this.processosSelecionados = []
            this.selecteds = []
        },

        /**
         * Abre a modal BRY
         */
        show () {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            axios.get(`${urlApi}/v1/exibirProcessosMontados/obterParametroAtualizacao`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })

            .then(response => {
                this.dados.permitirAjuizar = response.data.permitirAjuizamento
                if(this.dados.permitirAjuizar){
                    axios.post(`${urlApi}/v1/exibirProcessosMontados/obterPdfsPeticao`, this.selecteds, {
                        headers: {
                            'Content-Type': 'application/json',
                            'Authorization': token
                        }
                    })
                    .then(response => {
                        this.listaPdfsRetorno = response.data
                        this.parametrosAssinatura.arquivo = this.listaPdfsRetorno
                        this.$refs['modalBry'].show();
                    }).finally(() => {
                        this.loadingExit()
                    })
                }else{
                    this.$store.commit("setMessages", { message: 'Erro!', errors: ['Sistema da SEFA fechado para atualização de valores.'] });
                }
            })

        },
        hide () {
            this.$refs['modalBry'].hide();
        },

        /**
         * Enviar CDA's para protesto
         */
        desmontarProcesso() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadingEnter()
            axios.post(`${urlApi}/v1/exibirProcessosMontados/desmontarProcesso`, this.selecteds, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(() => {
                this.$store.commit("setMessages", { message: 'Sucesso', variant: 'success' , errors: ['Processo(s) desmontado(s) com sucesso!'] });
                this.selecteds = []
            })
            .catch((error) => {
                if(error.response.status === 400){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro ocorreu no desfazimento EPA-DAE, o histórico das dívidas selecionadas foi atualizado com o erro.'] });
                }
                if(error.response.status === 500){
                     this.$store.commit("setMessages", { message: 'Erro!', errors: ['Um erro de comunicação ocorreu com um sistema externo, tente novamente mais tarde. <a href="www.google.com">TESTE</a>'] });
                }
                this.selecteds = []
            })   
            .finally(() => {
                this.loadingExit()
                this.consultarDividas()
            })
        },

        /**
         * Lógica dos checks em nível dinâmico
         */
        toggleColuna(i) {
            let ativo;
            if(this.showColunms.includes(i)) {
                this.showColunms.splice(this.showColunms.indexOf(i), 1)
                this.fields[i].thClass = 'd-none'
                this.fields[i].tdClass = 'd-none'
                ativo = false
            } else {
                this.showColunms.push(i)
                this.fields[i].thClass = ''
                this.fields[i].tdClass = ''
                ativo = true
            }

            this.refreshConfigColunm(i, ativo)
        },

        /**
         * Atualiza as configurações de coluna do usuário
         */
        async refreshConfigColunm(i, ativo) {
            const token = JSON.parse(this.$store.getters.getUser).access_token

            const json = {
                codFuncionalidade: this.fields[i].codFuncionalidade,
                codColunaFuncionalidade: this.fields[i].codColunaFuncionalidade,
                ativo: ativo,
            }
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.post(`${urlApi}/v1/funcionalidade/atualizarConfiguracao`, json, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            }).catch((error) => {
                this.exibirErro(error)
            })          
        },

        /**
         * Exibe erros dos catch
         */
        exibirErro(error) {
            this.$store.commit("setMessages", { message: 'Erro!', errors: [error] });
        },

        /**
         * Verifica 'class' da tabela
         */
        checkClassTable(i) {
            if(i == 1 || i == 2 || i == 5 || i == 6)
                return 'text-center justify-content-center'
            if(i == 7)
                return 'text-right justify-content-center'
            return ''
        },

        /**
         * Exporta as CDA's em CVS
         */
        async exportCSV() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token

            this.loadCSV = true
            if(this.selecteds.length) {
                axios.post(`${urlApi}/v1/exibirProcessosMontados/exportarCsv`, this.selecteds, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                })
            } else {
                axios.post(`${urlApi}/v1/exibirProcessosMontados/exportarCsv/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`,this.filtro, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': token
                    }
                })
                .then(response => {
                    this.downloadCSV(response)
                }).finally(() => {
                    this.loadCSV = false
                })
            }
        },

        /**
         * Efetua o download do CSV a partir do response
         */
        downloadCSV(response) {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', 'exibirProcessosMontados.csv');
            document.body.appendChild(link);
            link.click();
        },

        /**
         * Volta para a dashboard
         */
        voltar() {
            this.$router.push('/dashboard');
        },

        abrirCdasDisponiveis() {
            this.$router.push('/ajuizamento/exibir-divida-disponivel');
        },

        abrirCdasAjuizadas() {
            this.$router.push('/ajuizamento/exibir-ajuizadas');
        },

        /**
         * Consultar divídas
         */
        async consultarDividas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                contribuinte: this.filtro.contribuinte,
                cadimcs: this.filtro.cadimcs,
                comarca: this.filtro.comarca,
                credito: this.filtro.credito,
                dtInscricaoInicio: this.filtro.dtInscricaoInicio,
                dtInscricaoFim: this.filtro.dtInscricaoFim,

            }

            this.consultarValorTotal()
            this.loadingEnter()
            axios.post(`${urlApi}/v1/exibirProcessosMontados/consultar/${this.ano}/${this.mes}?page=${this.configTable.currentPage}`+ this.escapePerPage() + `&sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
                this.resultado = response.data.resultado
                this.configTable.rows = response.data.rows
                 this.configTable.totalProcessos = response.data.totalProcessos

                this.resultado.forEach(result => {
                    result.dividas.forEach(divida => {
                        this.selecteds.forEach(selected => {
                            if(divida.id == selected.id) {
                                divida.checked = true
                                result.checked = true
                            }
                        })
                    })
                })
                
            }).finally(() => {
                this.loadingExit()
            })
        },

        /**
         * Consultar valor total das dividas e quantidade
         */
        async consultarValorTotal() {
            const urlApi = process.env.VUE_APP_ROOT_API

            const filtro = {
                numeroDivida: this.filtro.numeroDivida,
                cpfCnpj: this.filtro.cpfCnpj,
                contribuinte: this.filtro.contribuinte,
                cadimcs: this.filtro.cadimcs,
                comarca: this.filtro.comarca,
                credito: this.filtro.credito,
                dtInscricaoInicio: this.filtro.dtInscricaoInicio,
                dtInscricaoFim: this.filtro.dtInscricaoFim,

            }

            this.loadingEnter()
            axios.post(`${urlApi}/v1/exibirProcessosMontados/consultar/valorTotal/${this.ano}/${this.mes}?sortField=${this.configTable.sortField}&sortOrder=${this.configTable.sortOrder}`, filtro, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                }
            })
            .then(response => {
                this.configTable.totalGeral = response.data.valorTotal
                this.configTable.quantidadeGeral = response.data.totalDividas                
            })
        },

        /**
         * Listar comarcas
         */
        async listarComarcas() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/comarca/listar`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.comarcas = response.data
            })
        },

        /**
         * Listar os Tipos de Crédito
         */
        async listarTipoCredito() {
            const urlApi = process.env.VUE_APP_ROOT_API

            axios.get(`${urlApi}/v1/exibirProcessosMontados/listarTipoCredito`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
            .then(response => {
              this.dados.creditos = response.data
            })
        },


        /**
         * Obter configurações de colunas do usuário
         */
        async obterConfiguracaoUsuario() {
            const urlApi = process.env.VUE_APP_ROOT_API
            const token = JSON.parse(this.$store.getters.getUser).access_token
            const funcionalidade = 'CDAsExibirProcessosMontados'

            this.loadingEnter()
            axios.get(`${urlApi}/v1/funcionalidade/obterConfiguracao/${funcionalidade}`, {
                headers: {
                    'Content-Type': 'application/json',
                    'Authorization': token
                }
            })
            .then(response => {
                response.data.forEach((field, i) => {
                    if(field.ativo) {
                        this.showColunms.push(i + 1)
                    }
                    this.fields.push({
                        key: `${i + 1}`,
                        label: `${field.descricao}`,
                        sortable: true,
                        sortDirection: "desc",
                        class: this.checkClassTable(i),
                        thClass: field.ativo ? '' : 'd-none', tdClass: field.ativo ? '' : 'd-none',
                        codColunaFuncionalidade: field.codColunaFuncionalidade,
                        codFuncionalidade: field.codFuncionalidade
                    })
                })
            })
        },

        dadosUsuario() {
            let dados = '';
            apiCentralSeguranca.getInformacoesCidadao((JSON.parse(this.$store.getters.getUser).access_token))
            .then(res => {
                dados = res.data;
                this.cpfUsuarioLogado = dados.cpf
                //this.parametrosAssinatura.filters.CPFS.push(this.cpfUsuarioLogado)
            })
        },

        /**
         * Controle do Loading da Tabela
         */
        loadingEnter() {
            this.configTable.load = true
        },

        /**
         * Controle do Loading da Tabela    
         */
        loadingExit() {
            this.configTable.load = false
        }
    },
    created(){
       const urlApi = process.env.VUE_APP_ROOT_API
        axios.get(`${urlApi}/v1/exibirProcessosMontados/obterParametroAtualizacao`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': JSON.parse(this.$store.getters.getUser).access_token
                    }
                })
        .then(response => {
            this.dados.tempoAtualizacaoPagina = response.data.tempoAtualizacaoPagina
            if(this.dados.tempoAtualizacaoPagina != null){
                this.timer = setInterval(  this.consultarDividas ,  this.dados.tempoAtualizacaoPagina * 1000)
            }
        })
    },
    mounted() {

        const dataAtual = new Date(this.$store.getters.getDataMonitoramento)
        
        this.dadosUsuario()

        this.ano = dataAtual.getFullYear()
        this.mes = dataAtual.getMonth() + 1

        this.$store.commit("setMessages", {});

        this.consultarDividas()
        this.obterConfiguracaoUsuario()
        this.listarComarcas()
        this.listarTipoCredito()
    },
    beforeDestroy () {
      clearInterval(this.timer)
    }

}
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
<style>

.fonte-branca {
    color: #FFF;
}

.fonte-branca:hover {
    color: #FFF;
}

.fonte-branca:active {
    color: #FFF !important;
}

.table-sub-item, .table-sub-item > th, .table-sub-item > td {
    background-color: rgb(237, 237, 238);
}
</style>
